// Angular Imports
import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
// Shared Imports
import { ELocalStorageKeys } from '@shared/models'
import { AuthStore } from '@shared/store'

export const isLoggedGuard: CanActivateFn = (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot
) => {
	const router = inject(Router)
	const authStore = inject(AuthStore)

	// INFO: we get the tokens from the url if they exist and if not, we look for them in local storage
	const params = new URLSearchParams(window.location.search)
	const accessToken: string | undefined | null =
		params.get('access-token') || window.localStorage.getItem(ELocalStorageKeys.accessToken)
	const refreshToken: string | undefined | null =
		params.get('refresh-token') || window.localStorage.getItem(ELocalStorageKeys.refreshToken)

	if (accessToken && refreshToken) {
		if (!authStore.logged()) {
			authStore.signin({ accessToken, refreshToken })
		}
		return true
	} else {
		console.error(
			`the value of the accessToken (${accessToken}) and the refreshToken (${refreshToken}) is not a valid one`
		)

		if (authStore.logged()) {
			authStore.signout()
		}
		router.navigate(['/signin'])
		return false
	}
}
